export default {
  inserted: (el, fallback) => {
    let failedOnce = false;
    el.addEventListener("error", () => {
      if (!failedOnce) {
        el.src = fallback.value;
      }
      failedOnce = true;
    });
  }
};
